var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "cropper-upload" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.panel,
              expression: "panel"
            }
          ],
          staticClass: "container"
        },
        [
          _c("div", [
            _c("img", {
              staticClass: "image",
              attrs: { id: "image" + _vm.ckey, src: _vm.url, alt: "Picture" }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: { click: _vm.crop }
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cancel",
              attrs: { type: "button" },
              on: { click: _vm.cancel }
            },
            [_vm._v("取消")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", [
          _c("input", {
            ref: "inputer",
            staticClass: "inputfile",
            attrs: { type: "file", id: "change" + _vm.ckey, accept: "image" },
            on: { change: _vm.change }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "change" + _vm.ckey } }, [
            _c("div", { class: [_vm.ratio == "1" ? "show1" : "show2"] }, [
              _c(
                "div",
                {
                  class: [
                    _vm.ratio == "1" ? "picture-item1" : "picture-item2",
                    "picture"
                  ],
                  style: "backgroundImage:url(" + _vm.headerImage + ")"
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.headerImage,
                        expression: "!headerImage"
                      }
                    ],
                    staticClass: "el-icon-plus",
                    staticStyle: { display: "block" }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.headerImage,
                          expression: "!headerImage"
                        }
                      ],
                      staticStyle: { display: "block", "line-height": "20px" }
                    },
                    [_vm._v("上传图片")]
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }